<template>
  <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <title>Loading dots icon</title>
    <circle class="dot" cx="10" cy="20" r="3" />
    <circle class="dot" cx="20" cy="20" r="3" />
    <circle class="dot" cx="30" cy="20" r="3" />
  </svg>
</template>

<script>
export default {
  name: 'KIconLoadingDots'
}
</script>

<style scoped>
@keyframes wave {
  0%, 60%, 100% { transform: initial; }
  30% { transform: translateY(-20%); }
}
.dot {
  animation: wave 1200ms ease-in-out infinite;
  fill: currentColor;
  &:nth-child(2) { animation-delay: -300ms; }
  &:nth-child(3) { animation-delay: -150ms; }
}
</style>
